import { render, staticRenderFns } from "./NavSubMenu.vue?vue&type=template&id=4da25f2e&"
import script from "./NavSubMenu.vue?vue&type=script&lang=js&"
export * from "./NavSubMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports